export const MIYO_DISABLED_COLORS = [
  1, // Stainless

  90, // Pacific Glitter
  88, // Cypress Pine
];
